[
    {
        "institution": "University of Michigan",
        "degree": "Ph.D. in Computer Science",
        "info": "Advisor: Satinder Singh",
        "location": "Ann Arbor, MI",
        "startDate": "2018",
        "endDate": "ongoing"
    },
    {
        "institution": "University of Pennsylvania",
        "degree": "Masters of Computer and Information Technology",
        "gpa": 3.81,
        "location": "Philadelphia, PA",
        "startDate": "2015",
        "endDate": "2016"
    },
    {
        "institution": "St. John's College",
        "degree": "Bachelor of Arts (Philosophy / History of Mathematics)",
        "gpa": 3.48,
        "location": "Annapolis, MD",
        "startDate": "2005",
        "endDate": "2010",
        "info": "Thesis: \"Continuity in Dedekind's Essays on the Theory of Numbers\""
    }
]